import React from 'react';
import ChartHelper from "../../common/ChartHelper";
import {Line} from "react-chartjs-2";
import SessionStateManager from '../../common/SessionStateManager';
import {RequestTimeFrame} from "../../common/Constants";
import {Desktop, Mobile, Tablet} from "../../common/ResponsiveUtils";
import PropTypes from 'prop-types';
import _ from 'lodash';

class StatisticsChart extends React.Component {

    constructor(props){
        super(props);

        const session = new SessionStateManager(this.props.sessionKey , this.props.keepState );
        this.session = session;
        this.state = {
            time_frame: session.getState('time_frame',props.requestTimeFrame || RequestTimeFrame.Week),
            height : props.height
        };

    }

    getTimeFrame(){
        return this.state.time_frame;
    }

    persistSession(){

        this.session.putStateFrame({
            time_frame: this.state.time_frame
        }).save();

    }

    componentWillUnmount(){

        if(this.props.keepState){
            this.persistSession();
        }
        else{
            this.session.reset();
        }

    }

    handleTimeFrameChanged(frame){

        this.setState({
            time_frame: frame
        }, () => {

            //  persist
            if(this.props.keepState)
                this.persistSession();

            //
            if(this.props.onTimeFrameChanged){
                this.props.onTimeFrameChanged(frame);
            }

        });

    }

    render(){

        const props = this.props;
        const stats = props.data;
        const peakOffset = props.peakOffset || 50;
        const requestsTimeFrame = this.state.time_frame;

        let labels = ChartHelper.GenerateLabels(stats.time_frame,stats[ props.sections[0].key ]);

        let datasets = props.sections.map((s) =>{
            return {
                label: s.label,
                backgroundColor: s.backgroundColor,
                borderColor: s.borderColor,
                pointHoverBackgroundColor: '#fff',
                borderWidth: s.borderWidth,
                borderDash: s.borderDash ,
                data: stats[s.key].map((item) => item.peak )
            }
        });

        //  calculate max peak value
        let maxPeak = ChartHelper.FindMaxPeak(props.sections.map((s) => { return stats[s.key]})) + peakOffset;

        const mainChartOpts = {
            maintainAspectRatio: false,
            datasets: datasets,
            legend: {
                display: false
            },
            scales: {
                xAxes: [{
                    gridLines: {
                        drawOnChartArea: false,
                    }
                }],
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        maxTicksLimit: 5,
                        stepSize: Math.ceil(maxPeak / 5),
                        max: maxPeak
                    }
                }]
            },
            elements: {
                point: {
                    radius: 0,
                    hitRadius: 10,
                    hoverRadius: 4,
                    hoverBorderWidth: 3,
                }
            }
        };

        return <div>
            <div className="row">
                <div className="col-sm-5">

                    {_.isString(this.props.title) ? <React.Fragment>
                    <Desktop>
                        <h4 className="card-title mb-0">{this.props.title}</h4>
                    </Desktop>
                    <Mobile>
                        <h4 className="card-title mb-0">{this.props.titleResponsive || this.props.title }</h4>
                    </Mobile>
                    <Tablet>
                        <h4 className="card-title mb-0">{this.props.titleResponsive || this.props.title }</h4>
                    </Tablet>
                    </React.Fragment> : this.props.title}


                    {props.hint && <div className="small text-muted">{props.hint}</div>}
                </div>
                {this.props.onTimeFrameChanged && <div className="col-sm-7 hidden-sm-down">
                    <div className="btn-toolbar float-right" role="toolbar" aria-label="Time frame options">
                        <div className="btn-group mr-3" data-toggle="buttons">

                            {this.props.timeFrames.map((frame,index) => {

                                return <label key={index} className={`btn btn-outline-secondary ${this.props.timeFrameBtnSize ? `btn-${this.props.timeFrameBtnSize}` : ''} `  + (requestsTimeFrame == frame.value ?  "active" : null) }>
                                    <input type="radio" name={`time_frame_${frame.value}`} onClick={this.handleTimeFrameChanged.bind(this,frame.value) }/> {frame.label}
                                </label>

                            })}

                        </div>
                    </div>
                </div>}
            </div>
            <div className="chart-wrapper" style={{height: this.state.height, marginTop: this.props.chartMarginTop }}>
                <Line data={{labels: labels, datasets: datasets }} options={mainChartOpts} height={this.state.height}/>
            </div>
        </div>
    }

}

StatisticsChart.propTypes = {
    sessionKey: PropTypes.string ,
    keepState : PropTypes.bool,
    data: PropTypes.object,
    peakOffset :PropTypes.number,
    sections: PropTypes.array,
    height: PropTypes.number,
    title: PropTypes.any,
    titleResponsive: PropTypes.string,
    hint: PropTypes.string,
    onTimeFrameChanged: PropTypes.func,
    requestTimeFrame: PropTypes.string,
    timeFrames: PropTypes.array,
    timeFrameBtnSize: PropTypes.string,
    chartMarginTop: PropTypes.any
};

StatisticsChart.defaultProps = {
    height: 300,
    chartMarginTop: 40,
    timeFrames: [
        {
           value: RequestTimeFrame.Week,
           label: "Week"
        },
        {
            value: RequestTimeFrame.Month,
            label: "Month"
        },
        {
            value: RequestTimeFrame.Year,
            label: "Year"
        }
    ]
};

export default StatisticsChart;


// WEBPACK FOOTER //
// ./src/components/StatisticsChart/StatisticsChart.js